import {FormControl, Grid, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";
import {
  AUD_CURRENCY,
  AUS_COUNTRY_CODE,
  CAD_CURRENCY,
  CAN_COUNTRY_CODE,
  TXN_SCOPE,
  USD_CURRENCY
} from "../../utilities/constants";
import { sortDropdownByDisplayOrder } from "../../utilities/tp-validations";

function domainDropdown(props) {
  const compBids = parseInt(props.transactions.compBids, 10);
  const setDefaultCurrency = () => {
    const userDetails = props.isSimulateMode
        ? props.simulatedUserDetails
        : props.userDetails;
    let currency = USD_CURRENCY
    if(userDetails.countryCode===CAN_COUNTRY_CODE)
      currency = CAD_CURRENCY;
    if(userDetails.countryCode===AUS_COUNTRY_CODE)
      currency = AUD_CURRENCY;
      console.log('setDefaultCurrency:', currency);
    props.setBidsTextValue(props.id, currency, "JD");
    Array(compBids).fill(null).map((value, index) =>
        props.setBidsTextValue(props.id, currency, `C${index + 1}`));
    return currency;
  };
  const isError = (
      (props.id === "currency"
              ? (props.bids[props.id] === undefined || props.bids[props.id] === "")
              : props.transactions[props.id] === undefined || props.transactions[props.id] === ""
      ) && props.errorField.length !== 0
  );

  return (
      <Grid item xs={props.xs}>
          <FormControl fullWidth error ={isError}>
              <InputLabel
                  htmlFor="Films"
                  id="Films-label"
                  required={true}
              >
                  {props.label}
              </InputLabel>
        <Select
            label = {`${props.texts.SELECT} ${props.label}`}
            defaultValue={props.id !== "currency" ? "hide" : props.actionType.action === "Create" && setDefaultCurrency}
            value={props.transactions[props.id]}
            readOnly={props.actionType.action === "view"}
            disabled={(props.id === "compBids" &&
                    props.actionType.action === TXN_SCOPE.EDIT &&
                    props.transactions?.compBids === "1")}
            fullWidth={true}
            id={props.id}
            MenuProps={{ PaperProps: { sx: { maxHeight: 250 } } }}
            onChange={(event) => {
              if (props.id !== "currency" && props.id !== "compBids") {
                props.setDropdownValue(props.id, event.target.value);
              } else {
                props.setDropdownValue(props.id, event.target.value);
                props.setBidsTextValue(props.id, event.target.value, "JD");
                if (props.id === "currency") {
                  Array(compBids)
                      .fill(null)
                      .map((value, index) =>
                          props.setBidsTextValue(
                              props.id,
                              event.target.value,
                              `C${index + 1}`
                          )
                      );
                }
              }
              if (props.id === "dealType" && event.target.value === "Single Unit") {
                props.setTextValue("quantity", 1);
              }
            }}
        >
          {createDomainDropdownOption(
              sortDropdownByDisplayOrder(props.options),
              props.id
          )}
        </Select>
          </FormControl>
      </Grid>
  );
}

const createDomainDropdownOption = (options, id) => {
  if (options && options.length !== 0) {
    return options.map((item, index) => {
      const key = `${id}-${index}-${item.domainCode}`;
      return id === "currency" ? (
          <MenuItem key={key} value={item.domainCode}>
            {item.domainValue}
          </MenuItem>
      ) : (
          <MenuItem key={key} value={item.domainValue}>
            {item.domainValue}
          </MenuItem>
      );
    });
  }
};

export default domainDropdown;